module.exports = __webpack_public_path__ + "static/media/reminder.6e479741.svg";